const NumberInput = {
  variants: {
    outline: {
      field: {
        borderColor: 'gray.100',
        _focus: {
          borderColor: 'primary.main',
          boxShadow: 'none',
        },
        _error: {
          borderColor: 'danger.main',
          boxShadow: 'none',
        },
      },
    },
  },
};

export default NumberInput;
